export const BRAND_COLORS = ['#1bbbff', '#21333d', '#ec6454', '#f3a86d', '#5ec1b2'];

export const ENGAGEMENT_COLORS = ['#0066eb', '#35cd8d', '#ffbc3d', '#0087ff', '#d6b74a', '#2539b3', '#ff3c3c'];

export const PERFORMANCE_COLORS = [
  '#0066eb',
  '#da7294',
  '#35cd8d',
  '#ffbc3d',
  '#0087ff',
  '#ff3c3c',
  '#d6b74a',
  '#2539b3'
];

export const COLORS = [
  '#0066eb',
  '#702A8C',
  '#fe38a4',
  '#FF7326',
  '#9d2287',
  '#FF194D',
  '#e02c6b',
  '#f64557',
  '#ff6442',
  '#ffa600',
  '#35cd8d',
  '#0066eb',
  '#702A8C',
  '#fe38a4',
  '#FF7326',
  '#9d2287',
  '#FF194D',
  '#e02c6b',
  '#f64557',
  '#ff6442',
  '#ffa600',
  '#35cd8d',
  '#0066eb',
  '#702A8C',
  '#fe38a4',
  '#FF7326',
  '#9d2287',
  '#FF194D',
  '#e02c6b',
  '#f64557',
  '#ff6442',
  '#ffa600',
  '#35cd8d',
  '#0066eb',
  '#702A8C',
  '#fe38a4',
  '#FF7326',
  '#9d2287',
  '#FF194D',
  '#e02c6b',
  '#f64557',
  '#ff6442',
  '#ffa600',
  '#35cd8d'
];
